import React from 'react';

import Flag from '@atlaskit/flag';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { AnchorLink } from '../help-links';

const bitbucketServiceDeskLink = 'https://jdog.jira-dev.com/servicedesk/customer/portal/54';

const SDLink = <AnchorLink href={bitbucketServiceDeskLink}>the Bitbucket service desk</AnchorLink>;

const contents = (
  <p>
    The account linking was successful; however, the account that you attempted to link does not have access to
    Bitbucket Support Admin. Please visit {SDLink} and request access to Bitbucket Support Admin.
  </p>
);

export const NotBitbucketStaffError = () => (
  <Flag
    title="Account Linking Error - Missing Bitbucket Access"
    description={contents}
    appearance="normal"
    id="server-error"
    icon={<WarningIcon label="Account Linking Error" />}
  />
);
